import React, { createRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Text } from '../../../components/core'
import SvgClose from '../../../components/icons/Close'
import useMobile from '../../../other/Hooks/useMobile'
import Theme from '../../../Theme'

const Container = styled.div<{ body: boolean }>`
    position:absolute;
    top:70px;
    left:110px;
    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
        background-color:${Theme.colors.White};
        opacity:0.9;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        top:20%;
        width:90%;
        left:50%;
        margin-left:-45%;
        padding:20px;
        position: relative;
        z-index: 1;
        p{
            color:${Theme.colors.DarkGrey};
        }
    }
    .header-container {
        max-width: ${(body) => !!body ? '650px' : 'unset'};
        margin-bottom: 24px;

        @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
           color:${Theme.colors.DarkGrey} !important;
           border-bottom:2px solid #ED8B00;
           padding-bottom:10px;
           max-width:none;
        }
    }

    .body-container {
    max-width: 371px;
    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
        max-width:none;
        }
    }

    .close {
        position: absolute;
        top: 0px;
        right: 0px;
    }
`

const Svg = styled.svg`
    position: fixed;
    pointer-events: none;
    left: 0px;
    top: 0px;
    margin-top: -10px;
    right: 0px;
    height: 100%;
    width: 100%;
`;

const LS_NAME = 'liuna_clicked'
let cachedClicked = ''
export default function Welcome({ heading = '', body = '', hotspotPosition = { pageX: 0, pageY: 0 } as any }) {
    const ref = createRef<SVGSVGElement>()
    const textRef = createRef<HTMLDivElement>()
    const isMobile = useMobile()
    const [clicked, setClickd] = useState(cachedClicked)
    const [pos, setPos] = useState(null as DOMRect | null)

    useEffect(() => {
        if (body) return setPos(null)
        if (!textRef.current) return
        const newPos = textRef.current?.getBoundingClientRect()
        if (!newPos) return
        if (newPos.bottom !== pos?.bottom || newPos.left !== pos?.left || newPos.right !== pos?.right)
            setPos(newPos)
    }, [textRef, heading, body])


    const top = pos ? pos.bottom : 110
    const topPos = top + 25
    const leftContent = pos ? pos.left : 110
    const rightCorner = pos ? pos.right : leftContent + 500

    if (clicked) return null

    return (
        <Container
            onClick={() => {
                if (!isMobile) return
                localStorage.setItem(LS_NAME, LS_NAME)
                cachedClicked = LS_NAME
                setClickd(LS_NAME)
            }}
            body={!!body} key={heading}
        >
            {
                isMobile && <div className='close'>
                    <SvgClose fill='#000' />
                </div>
            }
            <div key={heading} className={`header-container ${heading ? 'fadeInNoDelay' : 'fadeInUp'}`}>
                <Text style={{ display: 'inline' }} ref={textRef} variant={!body ? 'Header7' : 'Header4'}>{heading}</Text>
            </div>
            {
                hotspotPosition.pageX
                    ? <Svg ref={ref}>
                        <line
                            x1={leftContent}
                            y1={topPos}
                            x2={rightCorner}
                            y2={topPos}
                            stroke="#ffffff"
                            strokeWidth={2}
                        />
                        <line
                            x1={rightCorner}
                            y1={topPos}
                            x2={hotspotPosition.pageX}
                            y2={hotspotPosition.pageY}
                            stroke="#ffffff"
                            strokeWidth={2}
                        />
                    </Svg>
                    : null
            }

            {
                body &&
                <div className='body-container fadeInUp'>
                    <Text variant='Body1'>{body}</Text>
                </div>
            }
        </Container>
    )
}

